import React, { useEffect, useState } from "react";
import { LeftArrow, StarIcon } from "../Assets/iconshere";
import { useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import apiClient from "../apiClient";
import logo from "../Assets/images/logo.png";
import { ENVIRONMENT_DETAIL, PUBLIC_ENVIRONMENT_LIST } from "../apiClient/apiEndpoints";
import { WebGLPlayer } from "../Components/Player/WebGLPlayer";
import moment from "moment";
import ReviewPage from "./ReviewPage";

const PlayEnv = () => {
  const navigate = useNavigate();
  const params = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const { id } = params;
  const [details, setDetails] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [list, setList] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [totalReview, setTotalReview] = useState(0);
  const [averageReview, setAverageReview] = useState(0);

  const getEnvironmentDetails = async () => {
    try {
      setDetailLoading(true);
      if (!id) return;
      let data = await apiClient.get(`${configData.config.API_URL}${ENVIRONMENT_DETAIL}/web/${id}`, {
        headers: {
          Authorization: `Bearer ${userData?.token ? userData?.token : ""}`,
          "Content-Type": "application/json",
        },
      });
      setDetails(data);
    } catch (error) {
      console.log(error);
    } finally {
      setDetailLoading(false);
    }
  };

  const getEnvironmentsList = async () => {
    try {
      setListLoading(true);
      let _list = await apiClient.get(`${configData.config.API_URL}${PUBLIC_ENVIRONMENT_LIST}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      setList(_list.filter((e) => e.uuid !== id));
    } catch (error) {
      console.error(error);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    getEnvironmentDetails();
    getEnvironmentsList();
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="env-page">
      <div className="container-fluid pt-3">
        <div
          className="d-flex align-items-center justify-content-start pb-2 ps-3"
          style={{ width: "90vw", margin: "0 auto" }}
        >
          <button onClick={() => navigate(-1)} className="backbtn cursor-pointer px-2" title="Back">
            <LeftArrow />
            Back
          </button>
        </div>
        <div className="screen-parent">
          <div className="screen-related">
            <div className="preview-related">
              <div className="left">
                <div className="play-screen">
                  <div className="webgl-screen">
                    {!detailLoading ? (
                      <WebGLPlayer type={"environment"} uuid={id} />
                    ) : (
                      <div className="main-load-screen load-parent">
                        <div className="load-avatar">
                          <svg viewBox="25 25 50 50">
                            <circle r="20" cy="50" cx="50"></circle>
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="env-details">
                  <div className="nameninfo">
                    <h6>{!detailLoading ? <> {details?.name} </> : <Skeleton width="50%" />} </h6>
                    <div className="persons">
                      {!detailLoading ? <> {details?.maxUsers} Users allowed </> : <Skeleton width="30%" />}
                    </div>
                    <div className="view-review">
                      {!detailLoading ? (
                        <>
                          <>
                            {details.session > 0 && (
                              <div className={totalReview > 0 ? "views" : "views zero"}>{details.session} Views </div>
                            )}
                            {totalReview > 0 && (
                              <>
                                {" "}
                                <div className="review">
                                  {averageReview}{" "}
                                  <span>
                                    {" "}
                                    <StarIcon /> ({totalReview} reviews){" "}
                                  </span>
                                </div>
                              </>
                            )}
                          </>
                        </>
                      ) : (
                        <Skeleton width="30%" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {!detailLoading && (
              <>
                <div className="row">
                  <div className="col-12">
                    <div className="env-details">
                      <div className="description-info">
                        {details.description && <p className="des">{details.description}</p>}
                        <div className="info-box">
                          <span className="release w-100">
                            <p>Release Date</p>
                            <span>{details?.createdAt && moment(details?.createdAt).format("DD MMMM YYYY")}</span>
                          </span>
                          {/* <div className='tags mt-2'>
                                                <p>Tags</p>
                                                <span>
                                                    <p>Tag 1</p>
                                                    <p>Tag 2</p>
                                                    <p>Tag 3</p>
                                                    <p>Tag 4</p>
                                                    <p>Tag 5</p>
                                                    <p>Tag 6</p>
                                                </span>
                                            </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rew">
                  <ReviewPage setAllReview={setTotalReview} setAverageReview={setAverageReview} />
                </div>
              </>
            )}
          </div>

          <div className="right h-100">
            <div className="play-sidebar">
              <h6>Related Environments</h6>
              <div className="sugg-list">
                {detailLoading
                  ? Array(3)
                      .fill(0)
                      .map((e) => {
                        return (
                          <div className="env-option">
                            <Skeleton width="98%" height="95%" />
                          </div>
                        );
                      })
                  : list.map((e) => {
                      return (
                        <div className="env-option" onClick={() => navigate(`/play/${e.uuid}`)}>
                          <img
                            src={e.thumbnail || logo}
                            onError={(e) => {
                              e.target.src = logo;
                              e.onerror = null;
                            }}
                          />
                          <span className="bg-shadow">{""}</span>
                          <p className="env-name">{e.name}</p>
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayEnv;
